import signalR, { Options } from "use-signalr-hub";
import { JWT_KEY } from "Auth/Models/AuthConstants";
import { HttpTransportType } from "@microsoft/signalr";
import { logError } from "Infrastructure/Utils/LoggingUtils";

const SERVER_TIMEOUT_MS = 60000;

const useSignalR = (hubUrl: string, options?: Options | undefined) => {
	function getToken(): string | null {
		const storedToken = localStorage.getItem(JWT_KEY);
		if (!storedToken) {
			logError(new Error("JWT token not found"));
			return null;
		}
		return storedToken.replace("Bearer ", "");
	}

	signalR.setDefaults({
		httpTransportTypeOrOptions: {
			skipNegotiation: true,
			transport: HttpTransportType.WebSockets,
			accessTokenFactory: () => getToken() ?? "",
		},
		automaticReconnect: {
			nextRetryDelayInMilliseconds: (retryContext) => {
				// Exponential backoff
				return Math.min(
					1000 * 2 ** retryContext.previousRetryCount,
					30000
				);
			},
		},
	});
	const hubConnection = signalR.useHub(hubUrl, {
		...options,
		onConnected: (hub) => {
			hub.serverTimeoutInMilliseconds = SERVER_TIMEOUT_MS;
			options?.onConnected?.(hub);
		},
	});
	return hubConnection;
};

export default useSignalR;
